import { supabase } from '../../supabase';

// platform_admin was removed in migration 20260401120000; only super_admin remains.
const PLATFORM_ROLES = new Set(['super_admin']);

const NO_PLATFORM_ACCESS = {
  isPlatformUser: false,
  platformRole: null,
  isActive: false,
  isRootPlatformSuperAdmin: false,
};

// Single-flight dedupe: concurrent callers for the same userId share one
// in-flight promise; the entry is cleared the moment it settles, so the next
// call always re-reads server state. No result is cached across calls.
const inflight = new Map();

async function fetchPlatformAccess(userId) {
  const { data, error } = await supabase
    .from('platform_users')
    .select('role, is_active, is_root')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    console.error('getPlatformAccess:', error);
    return NO_PLATFORM_ACCESS;
  }
  if (!data?.role || !PLATFORM_ROLES.has(data.role)) {
    return NO_PLATFORM_ACCESS;
  }

  return {
    isPlatformUser: true,
    platformRole: data.role,
    isActive: data.is_active === true,
    isRootPlatformSuperAdmin: data.is_root === true,
  };
}

export async function getPlatformAccess(userId) {
  if (!userId || typeof userId !== 'string') {
    return NO_PLATFORM_ACCESS;
  }

  const existing = inflight.get(userId);
  if (existing) return existing;

  const promise = fetchPlatformAccess(userId).finally(() => {
    inflight.delete(userId);
  });
  inflight.set(userId, promise);
  return promise;
}
